<template>
   
    <breadCrumbs title="Progress" main="UI Kits" title1="Progress" />  

         <div class="container-fluid">
            <div class="row">
              <div class="col-sm-12">
                  <basicProgress/>
                  <smallProgress/>
                  <largeProgress/>
                  <customHeight/>
                  <progressStates/>
                  <multipleBars/>
                  <progressStriped/>
                  <progressAnimated/>
              </div>
            </div>
         </div>
</template>
<script>
import basicProgress from "./basicProgress.vue"
import smallProgress from "./smallProgress.vue"
import largeProgress from "./largeProgress.vue"
import customHeight from "./customHeight.vue"
import progressStates from "./progressStates.vue"
import multipleBars from "./multipleBars.vue"
import progressStriped from "./progressStriped.vue"
import progressAnimated from "./progressAnimated.vue"
export default {
    components:{
        basicProgress,
        smallProgress,
        largeProgress,
        customHeight,
        progressStates,
        multipleBars,
        progressStriped,
        progressAnimated
    }
}
</script>